module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_7.bc1ccce9.png";